import { ref } from 'vue';
type IToastMessageType = 'success' | 'error';

interface IToastMessage {
	message: string;
	type: IToastMessageType;
}

const messages = ref<IToastMessage[]>([]);
const timeout = ref(3000);

export function useToast() {
	const showToast = (msg: string, msgType: IToastMessageType = 'success') => {
		messages.value.push({ message: msg, type: msgType });

		setTimeout(() => {
			messages.value.shift();
		}, timeout.value);
	};

	const showSuccess = (msg: string) => showToast(msg, 'success');
	const showError = (msg: string) => showToast(msg, 'error');

	return {
		messages,
		showSuccess,
		showError,
		timeout,
	};
}
